export default __webpack_public_path__ + "static/leeSangMainCharacter-58a6e41ec809a1809567d801aa663259.png";